import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { api } from "../../../../services";
import { Address } from "./Address";
import styles from "./sendAddressModal.scss"
import { NewAddressModal } from "./NewAddressModal";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import ReactGA from "react-ga4";
import { AddMessageModal } from "./AddMessageModal";

const modalToShowOptions = {
  chooseAddress: "chooseAddress",
  newAddress: "newAddress",
  addMessage: "addMessage",
}

export const SendAddressModals = ({ visible, handleCloseSendAddressModals, textFormSubmit }) => {
  const [addresses, setAddresses] = useState(null)
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [modalToShow, setModalToShow] = useState(modalToShowOptions.chooseAddress)
  const [loading, setLoading] = useState(false)

  const fetchAddresses = async (addressToSelectId?: string) => {
    setLoading(true)
    try {
      const response = await api.UserAddress.list();
      setAddresses(response)

      const addressToSelect = addressToSelectId ? response.find(address => address.id === addressToSelectId) : response[0]
      setSelectedAddress(addressToSelect)
    } catch (error) {
      setAddresses(null)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!addresses && visible) {
      fetchAddresses()
      ReactGA.event({
        category: "Inbox",
        action: "Click",
        label: "Otvoren flow za slanje adrese"
      });

    }
  }, [addresses, visible])


  const handleCloseAllModals = () => {
    handleCloseSendAddressModals()
    setModalToShow(modalToShowOptions.chooseAddress)
  }

  const handleBackToChooseAddressModal = () => {
    setModalToShow(modalToShowOptions.chooseAddress)
  }

  const handleAddNewAddressClick = () => {
    setModalToShow(modalToShowOptions.newAddress)

    ReactGA.event({
      category: "Inbox",
      action: "Click",
      label: "Dodavanje nove adrese"
    });


  }

  if (modalToShow === modalToShowOptions.newAddress) {
    return (
      <NewAddressModal
        visible={visible}
        handleClose={handleBackToChooseAddressModal}
        fetchAddresses={fetchAddresses}
      />
    )
  }

  if (modalToShow === modalToShowOptions.addMessage) {
    return (
      <AddMessageModal
        visible={visible}
        handleBackToChooseAddressModal={handleBackToChooseAddressModal}
        handleCloseAllModals={handleCloseAllModals}
        selectedAddress={selectedAddress}
        textFormSubmit={textFormSubmit}
      />
    )
  }

  return (
    <Modal
      visible={visible}
      onCancel={handleCloseSendAddressModals}
      title="Moje adrese"
      onOk={() => setModalToShow(modalToShowOptions.addMessage)}
      okText="Nastavi"
      centered
      bodyStyle={{ maxHeight: "calc(100dvh - 200px)", overflowY: "auto" }}
    >
      <div>
        {loading && (
          <Spin tip={"Učitavam..."} size="large" />
        )}
        {!loading && addresses && addresses.map((address, index) => (
          <Address
            key={address.id}
            address={address}
            setSelectedAddress={setSelectedAddress}
            isSelectedAddress={address.id === (selectedAddress && selectedAddress.id)}
            fetchAddresses={fetchAddresses}
          />
        ))}
        {!loading && addresses && addresses.length < 5 && (
          <button
            onClick={handleAddNewAddressClick}
            className={styles.addNewAddressButton}
          >
            <PlusOutlined className={styles.plusIcon} />
            <div style={{ textAlign: "left" }}>
              <p>Dodaj novu adresu</p>
              <p style={{ fontWeight: "normal" }}>Svaki sljedeći put možete je poslati u dva klika</p>
            </div>
          </button>
        )}
      </div>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/SendAddressModal/SendAddressModals.tsx